import React from 'react'
import useSteps from '../../hooks/useSteps'

export default function NextStepButton ({ label, style = 'default' }) {
  const { nextStep } = useSteps()

  return (
    <button className={['button', style].join(' ')} onClick={nextStep}>
      {label}
    </button>
  )
}
